import { render, staticRenderFns } from "./AddPurchasesInvoiceComponent.vue?vue&type=template&id=23fc1733"
import script from "./AddPurchasesInvoiceComponent.vue?vue&type=script&lang=js"
export * from "./AddPurchasesInvoiceComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports